import { tradeCompanyIdentityKey, type TradeCompanyOption } from './tradeBriefingCompanies';

export const TRADE_PORTAL_PREVIEW_AS = 'subcontractor';

export type TradePortalPreview = {
  uid?: string;
  email?: string;
  companyKey?: string;
};

function asParams(search: string | URLSearchParams | null | undefined): URLSearchParams {
  if (search instanceof URLSearchParams) return search;
  if (typeof search === 'string') {
    return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  }
  return new URLSearchParams();
}

export function parseTradePortalPreview(
  search: string | URLSearchParams | null | undefined,
): TradePortalPreview | null {
  const params = asParams(search);
  if (params.get('previewAs') !== TRADE_PORTAL_PREVIEW_AS) return null;
  const uid = params.get('uid')?.trim() || '';
  const email = params.get('email')?.trim().toLowerCase() || '';
  const companyKey = params.get('company')?.trim() || '';
  if (!uid && !email && !companyKey) return null;
  return {
    uid: uid || undefined,
    email: email || undefined,
    companyKey: companyKey || undefined,
  };
}

export function buildTradePortalPreviewSearch(preview: TradePortalPreview): string {
  const params = new URLSearchParams();
  params.set('previewAs', TRADE_PORTAL_PREVIEW_AS);
  if (preview.uid) params.set('uid', preview.uid);
  if (preview.email) params.set('email', preview.email);
  if (preview.companyKey) params.set('company', preview.companyKey);
  return `?${params.toString()}`;
}

export function tradePortalPreviewHref(preview: TradePortalPreview): string {
  return `/briefings${buildTradePortalPreviewSearch(preview)}`;
}

export function previewFromCompany(company: Pick<TradeCompanyOption, 'key' | 'invitedUid' | 'inviteEmail'>): TradePortalPreview {
  return {
    uid: company.invitedUid || undefined,
    email: company.inviteEmail || undefined,
    companyKey: company.key,
  };
}

export function tradeLinkMatchesPreview(
  link: { invitedUid?: string | null; inviteEmail?: string | null; companyName?: string | null },
  preview: TradePortalPreview,
): boolean {
  if (preview.uid && (link.invitedUid || '').trim() === preview.uid) return true;
  if (preview.email && (link.inviteEmail || '').trim().toLowerCase() === preview.email) return true;
  if (preview.companyKey && tradeCompanyIdentityKey(link) === preview.companyKey) return true;
  return false;
}
